
import { useEffect, useState } from 'react';
import { Button, Image, ProgressBar } from 'react-bootstrap';
import db from './db.js'
import Photos from './Photos';
import Video from './Video';
import Secret3 from './Secret3';
import Article from './Article';
import Blank from './Blank';


function Loader(props) {

  const [showLoader, setShowLoader] = useState(false);
  const [status, setStatus] = useState(0);
  const [mode, setMode] = useState('');
  const [share, setShare] = useState('');
  const [showFiles, SetShowFiles] = useState('');


  useEffect(async ()=>{
    async function getTheAlbum () {
      const albumInfo = await db.getAlbums(props.albumid,"","");
      
      // album info ahould be - {media:"15463", sender:'amer.hasoun32', mode: "photos", files:['kitchen1.jpg', 'kitchen2.jpg','kitchen3.jpg','kitchen4.jpg'] }
      setShare(albumInfo);
      // const ua = fetch()
      
      return
    }
      getTheAlbum() 
    }
    ,[])


// share is the db that sais what mode and which files and passess is it on as props mode- photos
  // const share = {mode: "photos", sender:'amer.hasoun32', files:['kitchen1.jpg', 'kitchen2.jpg','kitchen3.jpg','kitchen4.jpg', 'kitchen1.jpg', 'kitchen2.jpg','kitchen3.jpg', 'kitchen4.jpg']}
  // const share = {mode: "video", sender:'amer.hasoun32', files:'ramadan.mp4'}
  

  const handleClose = () => setShowLoader(false);
  const handleShow = () => setShowLoader(true);
  useEffect(()=>{
    handleShow();
    myFunction();
  }, [])

  let myVar;
  const myFunction = () => {
    setStatus(7);
    myVar = setTimeout(showPage, 1000);
  }
  const showPage = () => {
    setStatus(20);
    myVar = setTimeout(showPage2, 1000)
  }
  const showPage2 = () => {
    setStatus(30);
    myVar = setTimeout(showPage3, 1000)
  }
  const showPage3 = () => {
    setStatus(52)
    myVar = setTimeout(showPage4, 3000)
  }
  const showPage4 = () => {
    setStatus(61)
    myVar = setTimeout(showPage5, 3000)
  }
  const showPage5 = () => {
    setStatus(70)
    myVar = setTimeout(showPage6, 2000)
  }
  const showPage6 = () => {
    setStatus(72)
    myVar = setTimeout(showPage7, 3000)
  }
  const showPage7 = () => {
    setStatus(76)
    myVar = setTimeout(showPage8, 2000)
  }
  const showPage8 = () => {
    setStatus(78)
    myVar = setTimeout(showPage9, 3000)
  }
  const showPage9 = () => {
    setStatus(83)
    myVar = setTimeout(showPage10, 3000)
  }
  const showPage10 = () => {
    setStatus(93)
    myVar = setTimeout(showPage11, 2000)
  }
  const showPage11 = () => {
    setStatus(98)
    myVar = setTimeout(showPage12, 3000)
  }
  const showPage12 = () => {
    setStatus(99)
    myVar = setTimeout(showPage13, 3000)
  }
  const showPage13 = () => {
    setStatus(100);
    setShowLoader(false);
    SetShowFiles(true); 
  }

  // not in use right now
  const passedCaptcha = () => {  
    SetShowFiles(true)
  }

  return (
    <div className="App">
      <link href="https://fonts.googleapis.com/css2?family=Digital+7&display=swap" rel="stylesheet"></link>

      <header className={share.mode != "blank" ? "App-header" : "App-header2"} >
      
      <p style={{color:"lightblue", fontSize:"18px", fontWeight:"bold"}}>{share.sender}</p>{share.sender && share.mode== "photos"? <p style={{fontSize:"15px"}}>shared an album with you</p> :""}{share.sender && share.mode == "video" ? <p style={{fontSize:"15px"}}> shared a video with you</p>:""}{share.sender && share.mode == "secret" ? <p style={{fontSize:"15px"}}> shared a secret album with you</p>:""}{share.sender && share.mode == "article" ? <p style={{fontSize:"15px"}}> shared this with you</p>: ""}
      {showLoader && <ProgressBar style={{ width:"80%", margin:"auto"}} striped variant="warning" now={status} label={`${status}%`} />   }
      
      {(share.mode == "photos" && showFiles) && <Photos photos={share.files}/> }
      {(share.mode == "video" && showFiles) && <Video vids={share.files}/> }
      {(share.mode == "secret" && showFiles) && <Secret3 photos={share.files} seen={share.seen} albumid={share.media}/> }
      {(share.mode == "article" && showFiles) && <Article photos={share.files}  albumid={share.media} /> }
      {(share.mode == "blank" && showFiles) && <Blank photos={share.files}  albumid={share.media} /> }
      {(share.mode == undefined && showFiles) && <h2>Sorry, we did not find the media.</h2> }
      
      </header>
    </div>
  );
}

export default Loader;
